<template>
  <div>
    <div class="pc_all GenerateManagement LogoFile">
      <div class="GenerateManagementContent">
        <div class="GenerateManagementContent_nav">
          <div class="GenerateManagementContent_nav_left">
            <div class="nav_left_dd font20">幻灯片</div>
            <div class="nav_left_dt font14">
              全部原创设计，线上/线下全渠道，皆可商用。支持下载JPG、PNG和SVG源文件等格式
            </div>
          </div>
          <div class="GenerateManagementContent_nav_share">
            分享<img alt="" src="@a/ailogo/images/sv14.svg"/>
          </div>
        </div>
        <div class="GenerateManagementContent_txt">
          <div class="GenerateManagementContent_txt_scroll OScroll">
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" src="@a/ailogo/images/bg16.jpg"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">企业年度汇报PPT模板</div>
                  <div class="title_left_dt font14">下载文件格式：PPTX</div>
                </div>
                <div class="list_title_icon font16">
                  <img alt="" src="@a/ailogo/images/sv3on.svg"/>下载
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@c/header/header'

export default {
  data() {
    return {
      GenerateManagementWindowActive: false
    }
  },
  components: {
    Header
  },
  methods: {
    GenerateManagementWindowClass() {
      this.GenerateManagementWindowActive = !this.GenerateManagementWindowActive
    }
  }
}
</script>


<style>
@import "GenerateManagement.css";
</style>
